import { Broadcast } from '.'

function findChildFrame(iframeName: string | undefined) {
  return window.document.querySelector<HTMLIFrameElement>(
    'iframe' + (iframeName ? `[name="${iframeName}"]` : '')
  )
}

export interface BroadcastChild<E extends string, T = unknown>
  extends Broadcast<E, T> {
  childName?: string
}

export function broadcastToChild<E extends string, T = unknown>({
  data,
  eventName,
  childName,
  options,
  error
}: BroadcastChild<E, T>) {
  const childFrame = findChildFrame(childName)

  if (!childFrame) {
    throw new Error(
      childName
        ? `Could not find the targeted iframe: "${childName}".`
        : 'Could not find an iframe.'
    )
  }

  if (!childFrame.contentWindow) {
    throw new Error('Could not access iframe window object.')
  }

  childFrame.contentWindow.postMessage(
    JSON.stringify({
      eventName,
      data,
      options,
      error
    }),
    '*'
  )
}
